import { render, staticRenderFns } from "./viewAdminDetails.vue?vue&type=template&id=e5fe21c6&"
import script from "./viewAdminDetails.vue?vue&type=script&lang=js&"
export * from "./viewAdminDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports